// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget__widgetWrapper___3nCQS{width:100%;height:100%;padding:12.5px}.widget__widgetWrapper___3nCQS.widget__mobile___29Bt_{padding:0}.widget__widget___2lrfJ{width:100%;height:100%;border-radius:8px;box-shadow:0 2px 10px 0 #bdbdbd;background-color:#fafafa;display:flex;flex-direction:column;overflow:hidden;position:relative}.widget__modalContainer___1vS1m{position:relative;flex-grow:1;min-height:30px;display:flex;flex-direction:column}", ""]);
// Exports
exports.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"widgetWrapper": "widget__widgetWrapper___3nCQS",
	"mobile": "widget__mobile___29Bt_",
	"widget": "widget__widget___2lrfJ",
	"modalContainer": "widget__modalContainer___1vS1m"
};
module.exports = exports;
